import { createSlice } from '@reduxjs/toolkit'

export const eventsCategoriesSlice = createSlice({
  name: 'eventsCategories',
  initialState: {
    value: [],
  },
  reducers: {
    setCategories: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { setCategories } = eventsCategoriesSlice.actions;

export default eventsCategoriesSlice.reducer;